module.exports = "/assets/data/1258a20ddd8721974ba14140707b0158-N21.data.json";